module.exports = __webpack_public_path__ + "static/media/Gold.72c05e42.png";